import React from "react";
import {
  ConfirmationNumberOutlined,
  CompareArrowsOutlined,
  CodeOutlined,
  ShoppingCartOutlined,
  LoyaltyOutlined,
  BrushOutlined,
  GroupOutlined,
  RedeemOutlined,
} from "@material-ui/icons";

import Model from "../../hooks/Model";
import pageStyles from "./styles/mainStyles";
import Footer from "../../components/Footer";

const services = [
  {
    icon: <CompareArrowsOutlined />,
    name: "MARKETPLACE EVENTOS",
    color: "secondary",
    description:
      "La forma más rápida y fácil para que tengas herramientas para tu evento y conectar con tu comunidad",
    button: {
      text: "Mira los detalles",
      url: "https://ticketing.fravents.com",
    },
    image: require("../../assets/images/bg-card-service-1.gif"),
  },
  {
    icon: <ShoppingCartOutlined />,
    name: "GANA PREMIOS",
    description:
      "Participa en nuestras dinámicas para ganar entradas a eventos, productos y beneficios.",
    color: "primary",
    button: {
      text: "Ver dinámicas",
      url: "https://riff.win",
    },
    image: require("../../assets/images/bg-card-service-4.gif"),
  },
  {
    icon: <ConfirmationNumberOutlined />,
    name: "MARCA BLANCA",
    description:
      "Gestionar eventos, compra/venta de entradas QR y manejar tu equipo con tu propia plataforma de ticketing.",
    color: "pink",
    button: { text: "Conoce ReventOS", url: "https://reventos.fravents.com" },
    image: require("../../assets/images/bg-card-service-2.gif"),
  },
  {
    icon: <RedeemOutlined />,
    name: "AUTOMATIZAMOS PROCESOS",
    description:
      "Puedes compartirnos tus necesidades para revisar, planear y cotizar las mejores opciones sin ningún compromiso.",
    color: "primary",
    button: {
      text: "Mira como lo hacemos",
      url: "https://ai.fravents.com",
    },
    image: require("../../assets/images/bg-card-service-4.gif"),
  },
  {
    icon: <LoyaltyOutlined />,
    name: "SISTEMA $FROIN",
    description:
      "Nuestra economía esta construída en blockchain por medio de nuestra moneda $FROIN.",
    color: "blue",
    button: { text: "Visitar froin.club", url: "https://froin.club" },
    image: require("../../assets/images/bg-card-service-3.gif"),
  },
  {
    icon: <BrushOutlined />,
    name: "MARKETING Y DISEÑO DIGITAL",
    description:
      "Community management, Ads, diseño gráfico y edición de video para impulsar las ventas de tu marca.",
    color: "pink",
    button: {
      text: "Contáctanos",
      url: "https://wa.me/573012069045?text=Me%20interesa%20cotizar%20servicios%20con%20Fravents",
    },
    image: require("../../assets/images/bg-card-service-1.gif"),
  },
  {
    icon: <GroupOutlined />,
    name: "PRODUCCIÓN DE EVENTOS",
    description:
      "Organizacion integral de eventos en colaboracion con nuestro aliado Teten.",
    color: "secondary",
    button: {
      text: "Vamos a por ello",
      url: "https://wa.me/573012069045?text=Me%20interesa%20cotizar%20servicios%20con%20Fravents",
    },
    image: require("../../assets/images/bg-card-service-2.gif"),
  },
  {
    icon: <CodeOutlined />,
    name: "SOFTWARE PERSONALIZADO",
    description:
      "Creamos tiqueteras, e-commerce, apps, landings, hasta soluciones digitales únicas para tu negocio.",
    color: "gray",
    button: {
      text: "Hablemos",
      url: "https://wa.me/573012069045?text=Me%20interesa%20cotizar%20servicios%20con%20Fravents",
    },
    image: require("../../assets/images/bg-card-service-3.gif"),
  },
];

const MainPage = ({ history }) => {
  const styles = pageStyles();

  const renderServices = () =>
    services.map((service) => (
      <div className={styles.cardService} key={service.name}>
        {service.image && (
          <img
            alt={service.name}
            className={styles.imgBgCardService}
            src={service.image}
          />
        )}
        <div
          className={[styles.bgCardService, service.color].join(" ")}
          key={service.name}
        />
        {service.icon}
        <h3 className={styles.nameService}>{service.name}</h3>
        <p className={styles.descriptionService}>{service.description}</p>
        {service.button?.url && (
          <a href={service.button.url} className={styles.buttonService}>
            {service.button.text}
          </a>
        )}
      </div>
    ));

  const modeToServices = () => {
    const targetDiv = document.getElementById("services");
    targetDiv.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const detectVideoPlay = () => {
    const videoElement = document.getElementById("videoBanner");
    if (videoElement) {
      videoElement.play().catch((error) => {
        if (error?.name === "NotAllowedError") {
          Model.updateAlerts({
            message:
              'Verifica que no tengas el modo "Ahorro de batería", queremos que navegues sin problema',
            variant: "warning",
          });
        }
      });
    }
  };

  React.useEffect(() => {
    Model.setData("loading", false);
    Model.setData("isWhiteLabel", true);
    detectVideoPlay();
    return () => {
      Model.setData("isWhiteLabel", false);
    };
    //eslint-disable-next-line
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <img
          className={styles.logo}
          src={require("../../assets/images/Logo-Fravents-blanco.svg")}
          alt="Fravents"
        />
        <div className={styles.blank} />

        <a href="/dashboard" className={styles.button}>
          Ticketing
        </a>
        {/* <a href="https://froin.club" className={styles.button}>
          FROIN
        </a>
        <a href="/dashboard" className={styles.button}>
          Your-Shop
        </a>
        <a href="https://loyalty-froin.web.app/" className={styles.button}>
          Loyalty
        </a> */}
        <a
          href="https://wa.me/573012069045?text=Me%20interesa%20cotizar%20servicios%20con%20Fravents"
          className={styles.containedButton}
        >
          Contáctanos
        </a>
      </div>
      <div className={styles.banner}>
        <div className={styles.videoBackground}>
          <video
            id="videoBanner"
            width="100%"
            height="100%"
            autoPlay
            loop
            muted
            playsInline
          >
            <source
              src={
                Math.random() > 0.5
                  ? require("../../assets/videos/home-1.mp4")
                  : require("../../assets/videos/home-2.mp4")
              }
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
          <div />
        </div>
        <div className={styles.infoBanner}>
          <h1 className={styles.title}>
            Tu aliado digital para resaltar en la industria
          </h1>
          <h2 className={styles.description}>
            Creamos soluciones que impulsan tu marca
          </h2>
          <button className={styles.bannerCta} onClick={modeToServices}>
            Explora nuestros servicios
          </button>
        </div>
      </div>

      <div className={styles.services} id="services">
        {renderServices()}
      </div>

      <div className={styles.footer}>
        <Footer history={history} hideLang />
      </div>
    </div>
  );
};

export default MainPage;
